import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Typography, Snackbar } from '@mui/material';
import FormClasse from '../../components/Classes/FormClasse';
import { criarClasse, obterClasse, atualizarClasse } from '../../services/classeService';

const CriarEditarClassePage = () => {
  const [classe, setClasse] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      const fetchClasse = async () => {
        try {
          const data = await obterClasse(id);
          setClasse(data);
        } catch (error) {
          console.error('Erro ao buscar classe:', error);
          setSnackbarMessage('Erro ao carregar dados da classe');
          setOpenSnackbar(true);
        }
      };
      fetchClasse();
    }
  }, [id]);

  const handleSubmit = async (classeData) => {
    try {
      if (id) {
        await atualizarClasse(id, classeData);
        setSnackbarMessage('Classe atualizada com sucesso!');
      } else {
        await criarClasse(classeData);
        setSnackbarMessage('Classe criada com sucesso!');
      }
      setOpenSnackbar(true);
      setTimeout(() => navigate('/classes'), 2000);
    } catch (error) {
      console.error('Erro ao salvar classe:', error);
      setSnackbarMessage('Erro ao salvar classe');
      setOpenSnackbar(true);
    }
  };

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        {id ? 'Editar Classe' : 'Criar Nova Classe'}
      </Typography>
      <FormClasse onSubmit={handleSubmit} classeInicial={classe} />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={2000}
        onClose={() => setOpenSnackbar(false)}
        message={snackbarMessage}
      />
    </div>
  );
};

export default CriarEditarClassePage;